import { useNavigate } from 'react-router-dom';
import { clearComposerHandoff } from '@/features/research/composerPrefill';
import { QUICK_START } from './constants';

export default function ResearchHomeQuickStart() {
  const navigate = useNavigate();

  const launch = (path: string) => {
    clearComposerHandoff();
    navigate(path);
  };

  return (
    <section className="rh-quickstart" aria-labelledby="rh-qs-heading">
      <h2 id="rh-qs-heading" className="rh-qs-heading">
        Prefer a Manual Structured start? Pick a list type
      </h2>
      <div className="rh-qs-grid">
        {QUICK_START.map((q) => (
          <button key={q.path} type="button" className="rh-qs-card" onClick={() => launch(q.path)}>
            <span className="rh-qs-icon">
              <i className={`bi ${q.icon}`} aria-hidden="true" />
            </span>
            <span className="rh-qs-copy">
              <span className="rh-qs-title">{q.title}</span>
              <span className="rh-qs-sub">{q.sub}</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
